import { __read, __spreadArray } from "tslib";
import { ONE_HUNDRED_THOUSAND } from '../../constants';
export var getCatalogAppIdsOld = function (cart) {
    return getMappedUniqueList(cart.items, function (_a) {
        var catalogAppId = _a.catalogAppId;
        return catalogAppId;
    });
};
export var getCatalogAppIds = function (items) {
    return getMappedUniqueList(items, function (_a) {
        var _b;
        var source = _a.source;
        return (_b = source === null || source === void 0 ? void 0 : source.catalogReference) === null || _b === void 0 ? void 0 : _b.appId;
    });
};
export var getCatalogAppIdsV1 = function (items) {
    return getMappedUniqueList(items, function (_a) {
        var catalogReference = _a.catalogReference;
        return catalogReference === null || catalogReference === void 0 ? void 0 : catalogReference.appId;
    });
};
export var getItemTypes = function (items) {
    return getMappedUniqueList(items, function (_a) {
        var _b;
        var attributes = _a.attributes;
        return (_b = attributes === null || attributes === void 0 ? void 0 : attributes.itemType) === null || _b === void 0 ? void 0 : _b.preset;
    });
};
export var getItemTypesV1 = function (items) {
    return getMappedUniqueList(items, function (_a) {
        var itemType = _a.itemType;
        return itemType === null || itemType === void 0 ? void 0 : itemType.preset;
    });
};
export var getItemsCount = function (items) {
    var _a;
    /* istanbul ignore next */
    return (_a = items === null || items === void 0 ? void 0 : items.reduce(function (count, item) { var _a, _b; return count + ((_b = (_a = item.quantityInfo) === null || _a === void 0 ? void 0 : _a.confirmedQuantity) !== null && _b !== void 0 ? _b : 0); }, 0)) !== null && _a !== void 0 ? _a : 0;
};
export var getItemsCountV1 = function (items) {
    var _a;
    /* istanbul ignore next */
    return (_a = items === null || items === void 0 ? void 0 : items.reduce(function (count, item) { var _a; return count + ((_a = item.quantity) !== null && _a !== void 0 ? _a : 0); }, 0)) !== null && _a !== void 0 ? _a : 0;
};
function getMappedUniqueList(arr, mapper) {
    return getUniques((arr !== null && arr !== void 0 ? arr : []).map(mapper).filter(isDefined)).toString();
}
var getUniques = function (arr) {
    return __spreadArray([], __read(new Set(__spreadArray([], __read(arr), false))), false);
};
var isDefined = function (obj) {
    return !!obj;
};
export var getAdditionalFeesPrice = function (cart) {
    var _a, _b;
    /* istanbul ignore next */
    return ((_b = (_a = cart === null || cart === void 0 ? void 0 : cart.totals) === null || _a === void 0 ? void 0 : _a.additionalFeesTotal) !== null && _b !== void 0 ? _b : 0) * ONE_HUNDRED_THOUSAND;
};
export var getNumberOfAdditionalFees = function (cart) {
    var _a, _b;
    /* istanbul ignore next */
    return (_b = (_a = cart === null || cart === void 0 ? void 0 : cart.additionalFees) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : 0;
};
//# sourceMappingURL=bi.utils.js.map